import axios from '@fs/zion-axios'

const BASE_TEMPLE_KIOSKS_PATH = '/service/dmc/kiosks'

export function getKiosks(authorized) {
  let url = `${BASE_TEMPLE_KIOSKS_PATH}`
  if (authorized !== undefined) {
    url += `?authorized=${authorized}`
  }
  return axios.get(url)
}

export function registerKiosk(kioskData) {
  return axios.post(`${BASE_TEMPLE_KIOSKS_PATH}/register`, kioskData)
}

export function getKioskById(kioskId) {
  return axios.get(`${BASE_TEMPLE_KIOSKS_PATH}/${kioskId}`)
}

export function updateKiosk(kioskId, kioskData) {
  return axios.put(`${BASE_TEMPLE_KIOSKS_PATH}/${kioskId}`, kioskData)
}

export function deleteKiosk(kioskId) {
  return axios.delete(`${BASE_TEMPLE_KIOSKS_PATH}/${kioskId}`)
}
